import React, { useEffect, useState } from 'react';
import { ResultatAprenentatge, ResultatAprenentatgeForm } from '../services/api';

interface ResultatAprenentatgeModalProps {
  isOpen: boolean;
  resultat: ResultatAprenentatge | null;
  onClose: () => void;
  onSave: (data: ResultatAprenentatgeForm) => void;
}

function ResultatAprenentatgeModal({
  isOpen,
  resultat,
  onClose,
  onSave,
}: ResultatAprenentatgeModalProps) {
  const [codi, setCodi] = useState('');
  const [nom, setNom] = useState('');
  const [descripcio, setDescripcio] = useState('');
  const [hores, setHores] = useState('');
  const [continguts, setContinguts] = useState('');
  const [criterisAvaluacio, setCriterisAvaluacio] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;

    setCodi(resultat?.codi ?? '');
    setNom(resultat?.nom ?? '');
    setDescripcio(resultat?.descripcio ?? '');
    setHores(resultat?.hores ? String(resultat.hores) : '');
    setContinguts(resultat?.continguts ?? '');
    setCriterisAvaluacio(resultat?.criteris_avaluacio ?? '');
    setError('');
  }, [isOpen, resultat]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    if (!codi.trim() || !nom.trim()) {
      setError('El codi i el nom són obligatoris.');
      return;
    }

    const horesNum = hores.trim() ? Number(hores) : null;
    if (horesNum !== null && (!Number.isInteger(horesNum) || horesNum <= 0)) {
      setError('Les hores han de ser un nombre enter superior a 0.');
      return;
    }

    onSave({
      codi: codi.trim().toUpperCase(),
      nom: nom.trim(),
      descripcio: descripcio.trim(),
      hores: horesNum,
      continguts: continguts.trim(),
      criteris_avaluacio: criterisAvaluacio.trim(),
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-content-wide" onClick={(event) => event.stopPropagation()}>
        <h2>{resultat ? "Editar resultat d'aprenentatge" : "Nou resultat d'aprenentatge"}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="ra-codi">Codi del RA *</label>
              <input
                id="ra-codi"
                value={codi}
                onChange={(event) => setCodi(event.target.value.toUpperCase())}
                placeholder="Ex.: RA1"
                autoFocus
              />
            </div>
            <div className="form-group form-group-hours">
              <label htmlFor="ra-hores">Hores</label>
              <input
                id="ra-hores"
                type="number"
                min="1"
                value={hores}
                onChange={(event) => setHores(event.target.value)}
                placeholder="Ex.: 20"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="ra-nom">Nom del RA *</label>
            <input
              id="ra-nom"
              value={nom}
              onChange={(event) => setNom(event.target.value)}
              placeholder="Nom del resultat d'aprenentatge"
            />
          </div>

          <div className="form-group">
            <label htmlFor="ra-descripcio">Descripció</label>
            <textarea
              id="ra-descripcio"
              value={descripcio}
              onChange={(event) => setDescripcio(event.target.value)}
              placeholder="Descripció del resultat d'aprenentatge"
            />
          </div>

          <div className="form-group">
            <label htmlFor="ra-continguts">Continguts</label>
            <textarea
              id="ra-continguts"
              value={continguts}
              onChange={(event) => setContinguts(event.target.value)}
              placeholder="Continguts associats al resultat d'aprenentatge"
            />
          </div>

          <div className="form-group">
            <label htmlFor="ra-criteris">Criteris d'avaluació</label>
            <textarea
              id="ra-criteris"
              value={criterisAvaluacio}
              onChange={(event) => setCriterisAvaluacio(event.target.value)}
              placeholder="Criteris d'avaluació del resultat d'aprenentatge"
            />
          </div>

          {error && <p className="form-error">{error}</p>}

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel·lar
            </button>
            <button type="submit" className="btn btn-primary">
              {resultat ? 'Guardar canvis' : 'Crear RA'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ResultatAprenentatgeModal;
